import state from "./moduleAnchorState.js";
import mutations from "./moduleAnchorMutations.js";
import actions from "./moduleAnchorActions.js";
import getters from "./moduleAnchorGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
